import { Flex, Typography, theme } from 'antd';
import { PlatformSelectionTableEcho } from '@/routes/AudiencePage/charts/PlatformSelectionTableEcho';
import { Column } from '@/components/TableEcho';
import { GenderPlaysResponse, SelectedPlatform, GenderData } from '@/types/api/gender';
import { sortByPlatformDisplayOrder } from '@/utils/platformUtils';
import { uppercaseFirstLetter } from '@/utils';
import { formatPercentage } from '@/utils/numberFormattingUtils';
import { TableCellEcho } from '@/components/TableEcho';

export const GenderDataByPlatformEcho = ({
  data,
  selectedPlatform,
  handlePlatformChange,
}: {
  data: GenderPlaysResponse;
  selectedPlatform: SelectedPlatform<typeof data>;
  handlePlatformChange: (platform: SelectedPlatform<typeof data>) => void;
}) => {
  const { token } = theme.useToken();

  const getHighestValueLabel = (data: GenderData[]) => {
    const highestValueObject = [...data].sort((a, b) => b.value - a.value)[0];
    return (
      <Flex align="center" justify="flex-end" gap={token.marginXXS}>
        <Typography.Text style={{ color: token.colorText }}>
          {/* TODO: format this in the API or in a helper function? */}
          {uppercaseFirstLetter(highestValueObject.label.toLowerCase())}
        </Typography.Text>
        <Typography.Text
          style={{
            color: token.colorTextSecondary,
            fontSize: token.fontSizeSM,
            fontWeight: 300,
          }}
        >
          {/* TODO: format this in the API or in a helper function? */}
          {formatPercentage(highestValueObject.percentage)}%
        </Typography.Text>
      </Flex>
    );
  };

  const tableColumns: Column[] = [
    { key: 'radio', header: '', align: 'left' },
    { key: 'platform', header: 'Platform', align: 'left', className: 'px-2' },
    { key: 'top_gender', header: 'Top gender', align: 'right', className: 'px-2' },
  ];

  return (
    <Flex style={{ maxWidth: '100%' }}>
      <PlatformSelectionTableEcho<GenderPlaysResponse, GenderPlaysResponse['plays'][number]>
        idPrefix="gender-data"
        data={sortByPlatformDisplayOrder(data)}
        selectedPlatform={selectedPlatform}
        handlePlatformChange={handlePlatformChange}
        tableColumns={tableColumns}
        renderDataCells={(rowData: GenderPlaysResponse['plays'][number]) => (
          <TableCellEcho align="right" className="px-2">
            {getHighestValueLabel(rowData.gender_distribution)}
          </TableCellEcho>
        )}
      />
    </Flex>
  );
};
